import { render, staticRenderFns } from "./4-Payment.vue?vue&type=template&id=3759e53c&scoped=true"
import script from "./4-Payment.vue?vue&type=script&lang=js"
export * from "./4-Payment.vue?vue&type=script&lang=js"
import style0 from "./4-Payment.vue?vue&type=style&index=0&id=3759e53c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3759e53c",
  null
  
)

export default component.exports